<ion-content class="unauthorized-page">
  <div class="una-wrapper">
    <div class="una-card">

      <div class="una-icon-ring">
        <ion-icon color="light" name="key-outline"></ion-icon>
      </div>

      <h1 class="una-title">{{ 'mainauth.unauthorized.title' | translate }}</h1>

      <p class="una-body">
        @if (featureTitle) {
          {{ 'mainauth.unauthorized.featureBody' | translate: { feature: featureTitle } }}
        } @else {
          {{ 'mainauth.unauthorized.body' | translate }}
        }
      </p>

      <div class="una-divider"></div>

      <p class="una-hint">
        {{ 'mainauth.unauthorized.hint' | translate }}
      </p>

      <button class="una-home-btn" routerLink="/home">
        <ion-icon color="light" name="home-outline"></ion-icon>
        {{ 'mainauth.unauthorized.home' | translate }}
      </button>

    </div>
  </div>
</ion-content>
